var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path28, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveMountain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 4000 445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M302.59 264.18l19.55-13.68 17.59-14.66h19.54l19.54-1.95 13.69-7.82 36.15 7.82 15.64-1.96 22.47-9.77 16.62-12.7 22.47 4.88 16.61-7.81 26.39 27.36 20.52 20.52 32.25 12.7 7.81 8.8 19.55 14.66 2.93 8.79-329.32-35.18z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M471.68 277.97l.63 3.11h-2.62v-3.11h1.99z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M467.71 277.97l-.64 3.11h2.62v-3.11h-1.98z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M469.69 261.95l-12.52 17.1 8.19-2.09 4.33 1.86v-16.87z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M469.69 256.39l-10.55 14.42 6.9-1.76 3.65 1.56v-14.22z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M469.69 252.61l-7.86 10.76 5.14-1.32 2.72 1.17v-10.61z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M469.69 261.95l12.53 17.11-8.19-2.1-4.34 1.86v-16.87z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M469.69 256.4l10.56 14.41-6.9-1.76-3.66 1.56V256.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M469.69 252.62l7.87 10.75-5.14-1.31-2.73 1.16v-10.6z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M384.22 271.13l.64 3.11h-2.62v-3.11h1.98z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M380.25 271.13l-.63 3.11h2.62v-3.11h-1.99z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M382.24 255.1l-12.53 17.11 8.19-2.09 4.34 1.86V255.1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M382.24 249.55l-10.56 14.42 6.9-1.76 3.66 1.56v-14.22z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M382.24 245.77l-7.87 10.76 5.14-1.32 2.73 1.17v-10.61z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M382.24 255.11l12.52 17.11-8.19-2.1-4.33 1.86v-16.87z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M382.24 249.56l10.55 14.41-6.9-1.76-3.65 1.56v-14.21z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M382.24 245.78l7.86 10.75-5.14-1.31-2.72 1.16v-10.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M443.11 274.1l.72 3.53h-2.96v-3.53h2.24z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M438.62 274.1l-.71 3.53h2.96v-3.53h-2.25z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M440.87 255.98l-14.15 19.35 9.25-2.36 4.9 2.1v-19.09z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M440.87 249.7l-11.93 16.31 7.8-2 4.13 1.77V249.7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M440.87 245.42l-8.9 12.17 5.82-1.49 3.08 1.32v-12z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M440.87 255.98l14.15 19.36-9.25-2.37-4.9 2.1v-19.09z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M440.87 249.7l11.92 16.31-7.8-1.99-4.12 1.77V249.7z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M440.87 245.43l8.89 12.16-5.81-1.49-3.08 1.32v-11.99z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M592.59 321.14l73.85-18.78 32.11 3.71 32.2-13.89 35.31-2.01 18.09-10.15 11.72.55 2.96-.6 5.4-5.61 18.96 2.36 37.66 10.57 19.46 7.52 14.08-3 10.25.48 14.54 2.88 7.84 4.78 21.93 1.76 20.71-3.43 43.68 7.2 23.92 6.26 30.81-.02 26.88-9.74 26.07-8.31 33.67 1.58 15.2-11.02 18.64-6.46 14.15-4.47 11.33-6.81 22.14-2.62 27.81 1.31 15.55-2.94 26.07-8.31 23.46.37 6.42 3.97 19.7 2.39 15.37.73 15.2 4.38 23.92 6.26 2.2.11 18.16 3.79 7.39-1.12 18.05-9.43 26.95-11.2 4.56-3.46 37.36-14.38 13.56-7.43 18.09 7.13 47.9-6.23 6.38 4.71 17.89 9.64 29.01 7.24 5.62 5.4 27.13 15.95 5.2 14.18 19.42 8.25 12.8 8.68 12.03 9.37 14.19 10.2 21.11 19.34-189.96 60.76-770.65 20.97-221.45-103.36z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M4001.36 284.62s-78.86-.86-202.66 7.98c-139.67 9.98-337.04 46.4-417.7 55.11l-.3.03h-.11l-10.49 1.14c-82.36 8.91-172.61 16.04-256.29 21.2-49.78 3.07-99.73 5.45-148.45 7.07-53.74 1.79-107.2 2.7-158.91 2.7-30.6 0-61.23-.32-91.04-.95-31.14-.65-62.23-1.67-92.41-3.01-31.49-1.4-62.83-3.19-93.14-5.33-31.57-2.22-62.94-4.88-93.22-7.9-66.75-6.65-135.7-12.95-204.94-18.71-64.48-5.38-189.04-13.24-238.65-15.04-47.64-2.12-97.99 0-97.99 0-33.1 1.79-116.18 9.65-159.21 15.03-46.18 5.77-92.19 12.06-136.71 18.71-20.21 3.02-41.13 5.68-62.19 7.91-20.23 2.13-41.14 3.93-62.14 5.33-20.13 1.34-40.88 2.35-61.65 3-19.89.63-40.32.95-60.73.95-34.49 0-70.17-.91-106.01-2.7-32.5-1.62-65.82-4-99.03-7.07-55.82-5.16-111.98-12.29-166.92-21.2l-6.99-1.13h-.08l-.2-.04c-53.8-8.71-114.78-18.57-177.52-28.25-72.23-11.14-135.15-20.24-192.36-27.81-33.44-4.42-65.5-8.39-95.27-11.8-32.3-3.69-63.02-6.85-91.29-9.38-30.32-2.71-58.83-4.79-84.73-6.19-27.54-1.48-53-2.24-75.64-2.24-24.05 0-45.66.85-64.27 2.51a708.474 708.474 0 00-35.48 4.1 680.417 680.417 0 00-33.99 5.72 661.741 661.741 0 00-63.56 15.7c-18.05 5.44-37.57 12.35-55.08 19.35l-.17 137.46 1930.33-1h.13l2067.03.71.03-161.97z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1296.19 381.39l1.04 5.52h-4.33v-5.52h3.29z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1289.61 381.39l-1.04 5.52h4.33v-5.52h-3.29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1292.9 353.07l-20.7 30.25 13.54-3.7 7.16 3.28v-29.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1292.9 343.26l-17.44 25.48 11.4-3.11 6.04 2.76v-25.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1292.9 336.58l-13.01 19 8.51-2.32 4.5 2.06v-18.74z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1292.9 353.08l20.7 30.24-13.54-3.7-7.16 3.28v-29.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1292.9 343.26l17.44 25.49-11.4-3.12-6.04 2.77v-25.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1292.9 336.58l13.01 19.01-8.51-2.32-4.5 2.06v-18.75z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1261.62 381.72l.8 3.97h-3.33v-3.97h2.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1256.56 381.72l-.8 3.97h3.33v-3.97h-2.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1259.09 361.35l-15.92 21.76 10.41-2.66 5.51 2.36v-21.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1259.09 354.29l-13.41 18.33 8.77-2.24 4.64 1.99v-18.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1259.09 349.49l-10 13.67 6.54-1.67 3.46 1.48v-13.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1259.09 361.36l15.93 21.75-10.42-2.66-5.51 2.36v-21.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1259.09 354.3l13.42 18.33-8.77-2.24-4.65 1.99V354.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1259.09 349.49l10.01 13.67-6.54-1.67-3.47 1.48v-13.48z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1334.1 383.6l.8 3.96h-3.33v-3.96h2.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1329.04 383.6l-.8 3.96h3.33v-3.96h-2.53z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1331.57 363.22l-15.92 21.76 10.41-2.66 5.51 2.36v-21.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1331.57 356.16l-13.42 18.34 8.77-2.25 4.65 1.99v-18.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1331.57 351.36l-10.01 13.67 6.54-1.67 3.47 1.48v-13.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1331.57 363.23l15.92 21.75-10.41-2.66-5.51 2.36v-21.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1331.57 356.17l13.42 18.33-8.78-2.24-4.64 1.99v-18.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1331.57 351.36l10.01 13.68-6.55-1.68-3.46 1.49v-13.49z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1207.03 376.24l.63 3.12h-2.62v-3.12h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1203.05 376.24l-.63 3.12h2.62v-3.12h-1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1205.04 360.22l-12.52 17.11 8.19-2.1 4.33 1.86v-16.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1205.04 354.67l-10.55 14.41 6.9-1.76 3.65 1.56v-14.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1205.04 350.89l-7.87 10.75 5.15-1.32 2.72 1.17v-10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1205.04 360.22l12.52 17.11-8.19-2.09-4.33 1.85v-16.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1205.04 354.67l10.55 14.42-6.9-1.77-3.65 1.57v-14.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1205.04 350.89l7.87 10.75-5.15-1.31-2.72 1.16v-10.6z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1169.96 375.85l.53 2.63h-2.21v-2.63h1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1166.6 375.85l-.53 2.63h2.21v-2.63h-1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1168.28 362.33l-10.56 14.44 6.9-1.77 3.66 1.57v-14.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1168.28 357.64l-8.9 12.17 5.82-1.49 3.08 1.32v-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1168.28 354.45l-6.64 9.08 4.34-1.11 2.3.98v-8.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1168.28 362.33l10.57 14.44-6.91-1.77-3.66 1.57v-14.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1168.28 357.64l8.91 12.17-5.83-1.49-3.08 1.32v-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1168.28 354.46l6.64 9.07-4.34-1.11-2.3.98v-8.94z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1363.64 396.79l.63 3.12h-2.62v-3.12h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1359.66 396.79l-.63 3.12h2.62v-3.12h-1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1361.65 380.77l-12.52 17.11 8.18-2.09 4.34 1.86v-16.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1361.65 375.22l-10.55 14.42 6.9-1.76 3.65 1.56v-14.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1361.65 371.44l-7.87 10.76 5.14-1.32 2.73 1.17v-10.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1361.65 380.78l12.52 17.11-8.19-2.1-4.33 1.86v-16.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1361.65 375.23l10.55 14.41-6.9-1.76-3.65 1.56v-14.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1361.65 371.45l7.87 10.75-5.15-1.32-2.72 1.17v-10.6z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1401.82 385.77l.64 3.12h-2.62v-3.12h1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1397.85 385.77l-.63 3.12h2.62v-3.12h-1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1399.84 369.75l-12.53 17.1 8.19-2.09 4.34 1.86v-16.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1399.84 364.19l-10.56 14.42 6.9-1.76 3.66 1.56v-14.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1399.84 360.42l-7.87 10.75 5.14-1.32 2.73 1.17v-10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1399.84 369.75l12.52 17.11-8.19-2.09-4.33 1.85v-16.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1399.84 364.2l10.55 14.42-6.9-1.77-3.65 1.57V364.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1399.84 360.42l7.87 10.75-5.15-1.31-2.72 1.16v-10.6z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1482.55 379.28l.63 3.12h-2.62v-3.12h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1478.57 379.28l-.63 3.12h2.62v-3.12h-1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1480.56 363.26l-12.52 17.11 8.19-2.09 4.33 1.86v-16.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1480.56 357.71l-10.55 14.42 6.9-1.76 3.65 1.56v-14.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1480.56 353.93l-7.87 10.76 5.15-1.32 2.72 1.17v-10.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1480.56 363.27l12.52 17.11-8.18-2.1-4.34 1.86v-16.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1480.56 357.72l10.55 14.41-6.9-1.76-3.65 1.56v-14.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1480.56 353.94l7.87 10.75-5.14-1.32-2.73 1.17v-10.6z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1231.5 404.18l.97 4.75h-4v-4.75h3.03z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.44 404.18l-.96 4.75h3.99v-4.75h-3.03z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1228.47 379.77l-19.07 26.07 12.47-3.19 6.6 2.82v-25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1228.47 371.31l-16.07 21.97 10.51-2.69 5.56 2.38v-21.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M1228.47 365.55l-11.99 16.39 7.84-2.01 4.15 1.78v-16.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1228.47 379.78l19.08 26.06-12.47-3.19-6.61 2.83v-25.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1228.47 371.32l16.08 21.96-10.51-2.68-5.57 2.38v-21.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1228.47 365.56l11.99 16.38-7.84-2-4.15 1.78v-16.16z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M805.51 328.6l.63 3.12h-2.62v-3.12h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M801.54 328.6l-.64 3.12h2.62v-3.12h-1.98z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M803.52 312.58L791 329.69l8.19-2.1 4.33 1.86v-16.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M803.52 307.03l-10.55 14.41 6.9-1.76 3.65 1.56v-14.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M803.52 303.25L795.65 314l5.15-1.32 2.72 1.17v-10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M803.52 312.58l12.53 17.11-8.19-2.09-4.34 1.85v-16.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M803.52 307.03l10.56 14.42-6.9-1.77-3.66 1.57v-14.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M803.52 303.25l7.87 10.75-5.14-1.31-2.73 1.16v-10.6z"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M1018.96 355.15s7.58 3.66 25.15 16.51c17.09 13.72 16.71 24.8.15 46.21-10.52 16.71 25.92 30.33 25.92 30.33s-23.32 1.09-28.89 0-27.13-.19-27.13-.19-8.99-11.92-7.35-26.69c1.64-14.77 35.35-23.37 28.23-38.58-7.12-15.21-30-29.54-30-29.54l13.92 1.96z"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M681.83 344.57l.81 3.97h-3.34v-3.97h2.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.78 344.57l-.81 3.97h3.33v-3.97h-2.52z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M679.3 324.2l-15.92 21.76 10.41-2.66 5.51 2.36V324.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M679.3 317.14l-13.41 18.34 8.77-2.25 4.64 1.99v-18.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M679.3 312.34l-10 13.67 6.54-1.67 3.46 1.48v-13.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M679.3 324.21l15.93 21.75-10.41-2.66-5.52 2.36v-21.45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M679.3 317.15l13.42 18.33-8.77-2.24-4.65 1.99v-18.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M679.3 312.34l10.01 13.68-6.54-1.68-3.47 1.49v-13.49z"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M419.43 302.71l.53 2.64h-2.21v-2.64h1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.07 302.71l-.53 2.64h2.21v-2.64h-1.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M417.75 289.19l-10.57 14.44 6.91-1.76 3.66 1.56v-14.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M417.75 284.51l-8.9 12.17 5.82-1.49 3.08 1.32v-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M417.75 281.32l-6.64 9.07 4.34-1.11 2.3.99v-8.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M417.75 289.2l10.57 14.44-6.91-1.77-3.66 1.57V289.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M417.75 284.51l8.91 12.17-5.83-1.49-3.08 1.32v-12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M417.75 281.32l6.64 9.08-4.34-1.11-2.3.98v-8.95z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M548.65 301.03l.63 3.12h-2.62v-3.12h1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.67 301.03l-.63 3.12h2.62v-3.12h-1.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M546.66 285.01l-12.52 17.11 8.19-2.1 4.33 1.86v-16.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M546.66 279.46l-10.55 14.41 6.9-1.76 3.65 1.56v-14.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M546.66 275.68l-7.87 10.75 5.15-1.32 2.72 1.17v-10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M546.66 285.01l12.52 17.11-8.18-2.09-4.34 1.85v-16.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M546.66 279.46l10.55 14.42-6.9-1.77-3.65 1.57v-14.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M546.66 275.68l7.87 10.75-5.14-1.31-2.73 1.16v-10.6z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M737.67 353.77l1.32 6.54h-5.49v-6.54h4.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.33 353.77l-1.32 6.54h5.49v-6.54h-4.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M733.5 320.19l-26.25 35.86 17.16-4.39 9.09 3.89v-35.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M733.5 308.55l-22.12 30.22 14.46-3.7 7.66 3.28v-29.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M733.5 300.63L717 323.17l10.79-2.76 5.71 2.45v-22.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M733.5 320.2l26.25 35.86-17.17-4.39-9.08 3.89V320.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M733.5 308.56l22.12 30.22-14.46-3.7-7.66 3.28v-29.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M733.5 300.64l16.5 22.54-10.79-2.76-5.71 2.44v-22.22z"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M509.69 303.75l1.03 5.09h-4.28v-5.09h3.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.19 303.75l-1.03 5.09h4.28v-5.09h-3.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M506.44 277.58l-20.45 27.95 13.37-3.42 7.08 3.03v-27.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M506.44 268.51l-17.23 23.55 11.27-2.88 5.96 2.56v-23.23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M506.44 262.34l-12.85 17.56 8.4-2.14 4.45 1.9v-17.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M506.44 277.59l20.46 27.94-13.38-3.42-7.08 3.04v-27.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M506.44 268.52l17.24 23.55-11.27-2.88-5.97 2.55v-23.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M506.44 262.35l12.86 17.56-8.41-2.15-4.45 1.91v-17.32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveMountain);
export default __webpack_public_path__ + "static/media/waveMountain.14a4e79d6d1f3951bf1e301ddc149de0.svg";
export { ForwardRef as ReactComponent };